(function () {
  'use strict';

  class ColourShowcase {
    constructor(el) {
      this.el           = el;
      this.activeSwatch = 0;
      this.activeButton = 0;

      this.slides       = el.querySelectorAll('.cs-gallery__slide');
      this.swatchBtns   = el.querySelectorAll('.cs-swatch');
      this.styleBtns    = el.querySelectorAll('.cs-style-btn');
      this.dots         = el.querySelectorAll('.cs-dot');
      this.swatchNameEl = el.querySelector('.cs-swatch-name');
      this.galleryMain  = el.querySelector('.cs-gallery__main');

      this._touchStartX = 0;

      this._bind();
      this._render();
    }

    get _slideCount() {
      return this.styleBtns.length || 1;
    }

    _goNext() {
      this.activeButton = (this.activeButton + 1) % this._slideCount;
      this._render();
    }

    _goPrev() {
      this.activeButton = (this.activeButton - 1 + this._slideCount) % this._slideCount;
      this._render();
    }

    _bind() {
      // Swatch buttons
      this.swatchBtns.forEach((btn, i) => {
        btn.addEventListener('click', () => {
          this.activeSwatch = i;
          this._render();
        });
      });

      // Style buttons (right panel)
      this.styleBtns.forEach((btn, i) => {
        btn.addEventListener('click', () => {
          this.activeButton = i;
          this._render();
        });
      });

      // Dot indicators
      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          this.activeButton = i;
          this._render();
        });
      });

      // Touch swipe
      if (this.galleryMain) {
        this.galleryMain.addEventListener('touchstart', e => {
          this._touchStartX = e.changedTouches[0].clientX;
        }, { passive: true });

        this.galleryMain.addEventListener('touchend', e => {
          const delta = e.changedTouches[0].clientX - this._touchStartX;
          if (Math.abs(delta) > 40) {
            delta < 0 ? this._goNext() : this._goPrev();
          }
        }, { passive: true });
      }
    }

    _render() {
      const s = this.activeSwatch;
      const b = this.activeButton;

      // Slides
      this.slides.forEach(el => {
        const active = parseInt(el.dataset.swatch, 10) === s &&
                       parseInt(el.dataset.button, 10) === b;
        el.classList.toggle('is-active', active);
      });

      // Dots
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === b);
      });

      // Swatch buttons
      this.swatchBtns.forEach((btn, i) => {
        btn.classList.toggle('is-active', i === s);
        btn.setAttribute('aria-pressed', String(i === s));
      });

      // Style buttons
      this.styleBtns.forEach((btn, i) => {
        btn.classList.toggle('is-active', i === b);
        btn.setAttribute('aria-pressed', String(i === b));
      });

      // Update CSS vars + swatch name from active swatch
      const activeSwatchBtn = this.swatchBtns[s];
      if (activeSwatchBtn) {
        const accent    = activeSwatchBtn.dataset.accent;
        const textColor = activeSwatchBtn.dataset.textColor;
        const label     = activeSwatchBtn.dataset.label;

        if (accent)    this.el.style.setProperty('--cs-accent', accent);
        if (textColor) this.el.style.setProperty('--cs-swatch-text', textColor);
        if (this.swatchNameEl && label) this.swatchNameEl.textContent = label;
      }
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-colour-showcase]').forEach(el => {
      if (!el._csInstance) {
        el._csInstance = new ColourShowcase(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', e => {
    const el = e.target.querySelector('[data-colour-showcase]');
    if (el) el._csInstance = new ColourShowcase(el);
  });

})();
